export default __webpack_public_path__ + "static/media/referral-claim-desktop.9b34bc71.png";